import {
	 SERVICE_FETCH,
	 SERVICE_FETCH_SUCCESS,
	 SERVICE_FETCH_FAIL,
} from '../actions';


export const serviceFetch = (servicelist) => ({
	type: SERVICE_FETCH,
	payload: { servicelist }
 });
 
 export const serviceSuccess = (servicelist) => ({
	type: SERVICE_FETCH_SUCCESS,
	payload: { servicelist }
 });
 
 export const serviceFail = (message) => ({
	type: SERVICE_FETCH_FAIL,
	payload: { message }
 });
 


